// extracted by mini-css-extract-plugin
module.exports =  {"destructive":"ButtonDestructive-module__destructive___ITJGK"};